import './App.scss';

import Main from './components/Main';

function App() {
  return (
    <div className="App">
      <h1>Expenses Calculator</h1>
      <Main />
    </div>
  );
}

export default App;
